
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-vs-native-teams-reminders-comparison",
      function () {
        return require("private-next-pages/article/teamsreminder-vs-native-teams-reminders-comparison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-vs-native-teams-reminders-comparison"])
      });
    }
  